import { z } from 'zod'
import { loadCollectionWithFallback } from '@/services/content/contentProvider'
import { fetchCollection } from '@/services/firebase/firestoreClient'

const terminSchema = z.object({
  date: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  title: z.string(),
  location: z.string(),
  year: z.number()
})

export type Termin = z.infer<typeof terminSchema>

type TerminDto = z.infer<typeof terminSchema>

const termineDataModule = import.meta.glob<TerminDto[]>('/src/data/termine.json', {
  import: 'default'
})

async function loadLocalArray(): Promise<TerminDto[]> {
  const loader = Object.values(termineDataModule)[0]
  if (!loader) throw new Error('Termine module not found')
  return loader()
}

export function loadTermine(): Promise<readonly Termin[]> {
  return loadCollectionWithFallback(
    terminSchema,
    () => fetchCollection('termine'),
    loadLocalArray,
    'termine'
  )
}
